/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getSite } from "_foundation/hooks/useSite";
import organizationService from "_foundation/apis/transaction/organization.service";
import {
  OrganizationApi,
  SwitchOrganizationToRequestData,
  XSwitchOrganizationApi,
} from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import { site as constantsSite } from "_foundationExt/constants/site";
import ensureObject from "tools/ensureObject";

const organizationApiInstance = new OrganizationApi(
  undefined,
  constantsSite.transactionContext
);

const switchOrganizationApiInstance = new XSwitchOrganizationApi(
  undefined,
  constantsSite.transactionContext
);

const organizationServiceExt = {
  /**
   * loads all organizations for user
   * @param parameters {storeId: string}
   */
  selfEntiledOrgs(parameters: any) {
    const site = getSite();
    const { storeId = site?.storeID, ...options } = ensureObject(parameters);

    return organizationApiInstance.getEntitledOrganizations(storeId, options);
  },

  /**
   * switch organization
   * @param payload
   * @param additionalOptions {storeId: string}
   */
  switchOrganizationTo(
    payload: SwitchOrganizationToRequestData,
    additionalOptions?: any
  ) {
    const site = getSite();
    const { storeId = site?.storeID, ...options } =
      ensureObject(additionalOptions);

    return switchOrganizationApiInstance.switchTo(
      storeId,
      undefined,
      payload,
      options
    );
  },
};

export default { ...organizationService, ...organizationServiceExt };
